import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { createDraftId } from "authoring/routes/project/lib/project-utils"
import { AmendsChanged } from "../schedule-editor-event-definitions.mjs"

export const upsertDraftAmends = api(async function upsertDraftAmends({ projectId, scheduleId, amends }) {
    const saved = await mutate(
        gql`
            mutation UpsertDraftAmends($projectId: String!, $scheduleId: String!, $amends: JSONObject!) {
                upsertDraftAmends(projectId: $projectId, scheduleId: $scheduleId, amends: $amends) {
                    id
                    referenceId
                    shortDescription
                    longDescription
                    type
                    payload
                    userId
                    userName
                    clientId
                    modified
                    date
                }
            }
        `,
        {
            projectId,
            scheduleId,
            amends,
        },
        { returns: "upsertDraftAmends" }
    )
    if (saved) AmendsChanged(createDraftId(projectId, scheduleId)).raiseOnce()
    return saved
})
